import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("vb_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("vb_token");
      if (!window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/auth")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
